// Dependencies
import React from 'react';

// Assets
import './ErrorBoundary.css';


export const UNAUTHORIZED_CSS_FILE_NAME = 'Unauthorized';
// export const UNAUTHORIZED_GUEST_USER = 'Unauthorized';


class ErrorBoundary extends React.Component {
  state = {
    error: null,
    errorInfo: null
  };

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo
    });
    // You can also log error messages to an error reporting service here
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      const { message } = error;
      const title = message === UNAUTHORIZED_CSS_FILE_NAME // UNAUTHORIZED_GUEST_USER
        ? 'Access to this data has been denied.'
        : 'Something went wrong.';

      return (
        <div className="ErrorBoundary p-3">
          <div className="alert alert-secondary">
            <h3 className="alert-heading">{title}</h3>
            <p className="lead mt-3">
              Please contact support@ripplenami.com for assistance.
            </p>
          </div>
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
